import { PanoramaDetails } from '../services/UploadManagementServiceTypes';
import { AframePosition } from './AframeTypes';

export class CirclePosition {
  private circleDistanceFromCenter = 5;
  constructor(
    private currentPanorama: Pick<PanoramaDetails, 'camera'>,
    private panorama: Pick<PanoramaDetails, 'camera'>,
  ) {}

  calculate(): AframePosition {
    const translation = this.getTranslatedPosition();
    const rotation = this.getRotatedPosition(translation);

    return this.getReducedPosition(rotation);
  }

  private get camera() {
    return this.panorama.camera;
  }

  private get currentCamera() {
    return this.currentPanorama.camera;
  }

  private getTranslatedPosition() {
    return {
      x: this.camera.x - this.currentCamera.x,
      y: this.camera.y - this.currentCamera.y,
      z: this.camera.z - this.currentCamera.z,
    };
  }

  private getRotatedPosition({ x, y, z }: AframePosition) {
    // pitch is omitted in panoramas
    const { yaw: b, roll: a } = this.currentCamera;
    const cosAlpha = Math.cos(-a);
    const sinAlpha = Math.sin(-a);
    const cosBeta = Math.cos(-b);
    const sinBeta = Math.sin(-b);
    const cosGamma = Math.cos(0); // 1
    const sinGamma = Math.sin(0); // 0

    return {
      x:
        x * (cosAlpha * cosBeta) +
        y * (cosAlpha * sinBeta * sinGamma - sinAlpha * cosGamma) +
        z * (cosAlpha * sinBeta * cosGamma + sinAlpha * sinGamma),
      y:
        x * (sinAlpha * cosBeta) +
        y * (sinAlpha * sinBeta * sinGamma + cosAlpha * cosGamma) +
        z * (sinAlpha * sinBeta * cosGamma - cosAlpha * sinGamma),
      z: x * -sinBeta + y * cosBeta * sinGamma + z * cosBeta * cosGamma,
    };
  }

  private getReducedPosition({ x, y, z }: AframePosition) {
    const distance = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2) + Math.pow(z, 2));
    if (!distance) {
      return { x: 0, y: 0, z: 0 };
    }
    const reduction = this.circleDistanceFromCenter / distance;
    return {
      z: z * reduction,
      y: y * reduction,
      x: x * reduction,
    };
  }
}
